import React, { useState, useEffect, useRef } from "react";
import { Input, Select, Button, message, Modal, Menu, InputNumber } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { jobs, simulation, deleteJob, getJob, updateJob,subjobs,getSubjobs,getSubjob,projects,flows } from "@/services/common";
import { userJobInteraction } from "@/services/jobs";
import { designValue,createDesignValue,getDesignValue} from '@/services/design';
import userInfo from "@/Components/user";
import { buildTaskInput } from "./func/buildInput";
import { buildNodeDataByInput } from "./func/buildNodeDataByInput";
import GroupCalParamsPreview from "@/Components/Diagram/ParamsPreview";
import { validateInput } from "@/Components/Diagram/validateInput";
import { typeMap3 } from "@/constants/dataMap";
import TreeMenu from "./TreeMenu/TreeMenu";
import DesignTree from "./DesignTree";
import type { JobData } from "./TreeMenu/types";
import isEqual from "lodash/isEqual";
import emptyJosn from "../../../Main/empty.json";
import {openErrorNotification} from '@/Components/Diagram/ErrorsNotice'

interface TaskListProps {
  jsonData: any;
  state: any;
  close: () => void;
  selectElement: (newElementType: string, newElement: any) => void;
  saveTaskVariable: number;
  newTreeData: any;
  clearSelectVariable: boolean;
  setClearSelectVariable:()=>void;
  setTaskListFunc: (newTaskList: any) => void;
  setSelectedItemFunc: (newSelectedItem: any) => void;
  selectedNodeByFlow: any;
  resultDrawOpen?: any;
  setResultDrawOpen?: any;
  setGroupeCalOpen?: any;
  flowJsonData?:any;
  notificationApi:any;
  notificationKey:any;
  openImportPageVariable:number;
  setJobId:(newJobId)=>void;
  setAllowUpDiagrams:(newAllowUpDiagrams)=>void;
  taskListVariable?:boolean;
  queryTaskVariable?:number;
  setCurResultInfo?:any;
  setChangeLinkFlowValue?:any;
  readonly?:boolean;
  setReadonly?:(newReadonly)=>void;
  saveDiagram?:()=>void;
  setSearchElementName?:(newSearchElementName)=>void;
  queryAllSubJobsToFlowValue?:any;
  groups:any;
  taskListWidth?:number;
  setTaskListSelectGroup:(newTaskListSelectGroup)=>void;
  runPartTaskByDiagram:any;
  setRefreshResVariable:()=>void;
  setIsNowNeedOpenPramDrawer:(newIsNowNeedOpenPramDrawer)=>void;
  setCloseModalVariable:()=>void;
  upParamDrawer:(node)=>void;
  clearHigh:()=>void;
}

//工艺段展示顺序：列表包含下列工艺段时按此流程顺序展示，未包含的保持原顺序排在其后
const GROUP_DISPLAY_ORDER = [
  "原料气冷却",
  "H2S/CO2吸收",
  "预洗闪蒸塔",
  "闪蒸再生和H2S浓缩",
  "热再生",
  "甲醇水分离",
  "尾气洗涤",
];
const sortGroupsByDisplayOrder = (groups: any[]) =>
  [...(groups || [])].sort((a: any, b: any) => {
    const ia = GROUP_DISPLAY_ORDER.indexOf(a?.groupName);
    const ib = GROUP_DISPLAY_ORDER.indexOf(b?.groupName);
    if (ia === -1 && ib === -1) return 0;
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

const TaskList: React.FC<TaskListProps> = ({
  jsonData,
  state,
  close,
  selectElement,
  saveTaskVariable,
  newTreeData,
  clearSelectVariable,
  setClearSelectVariable,
  setTaskListFunc,
  setSelectedItemFunc,
  selectedNodeByFlow,
  resultDrawOpen,
  setResultDrawOpen,
  setGroupeCalOpen,
  flowJsonData,
  notificationApi,
  notificationKey,
  openImportPageVariable,
  setJobId,
  setAllowUpDiagrams,
  taskListVariable,
  queryTaskVariable,
  setCurResultInfo,
  setChangeLinkFlowValue,
  readonly,
  setReadonly,
  saveDiagram,
  setSearchElementName,
  queryAllSubJobsToFlowValue,
  groups,
  taskListWidth,
  setTaskListSelectGroup,
  runPartTaskByDiagram,
  setRefreshResVariable,
  setIsNowNeedOpenPramDrawer,
  setCloseModalVariable,
  upParamDrawer,
  clearHigh,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [selectButton, setSelectButton] = useState("分组");
  const [buttonAbled, setButtonAbled] = useState(true);
  const [taskList, setTaskList] = useState([]);
  const [desList, setDesList] = useState([]);
  const [selectedElements, setSelectedElements] = useState<string[]>([]);
  const [alreadyTaskIds, setAlreadyTaskIds] = useState([]);
  const [selectedItem, setSelectedItem] = useState<SelectedNode | null>(null);
  const selectedItemRef = useRef(selectedItem);
  const queryAllSubJobsToFlowVariable = useRef(false);
  const [newJsonData, setNewJsonData] = useState(null);
  const [creatDesVariable, setCreatDesVariable] = useState<number>(0);
  const [creatDesType, setCreatDesType] = useState<string>(null);
  const [importVariable, setImportVariable] = useState(false);
  const [importDataByTree,setImportDataByTree] = useState(null);
  const [expandFirstItemVariable,setExpandFirstItemVariable] = useState(null);
  const pendingJobIdRef = useRef<string | null>(null);
  const pendingResolveRef = useRef<(() => void) | null>(null);
  const taskListRef = useRef([]);
  const pendingSaveRef = useRef(false);
  const [selectImportButton,setSelectImportButton] = useState("task");  //task,design,real,combo,elementRun,otherProject
  //"其他项目流程"导入来源：项目 → 流程 → 计算任务 三级选择
  const [otherProjectList,setOtherProjectList] = useState<any[]>([]);
  const [otherFlowList,setOtherFlowList] = useState<any[]>([]);
  const [otherJobList,setOtherJobList] = useState<any[]>([]);
  const [otherProjectId,setOtherProjectId] = useState<any>(null);
  const [otherFlowId,setOtherFlowId] = useState<any>(null);
  const [otherJobId,setOtherJobId] = useState<any>(null);
  const [otherLoading,setOtherLoading] = useState(false);
  const [loadingVariable, setLoadingVariable] = useState(false);
  const [creatTaskNameVariable, setCreatTaskNameVariable] = useState(null);
  const [creatTaskName, setCreatTaskName] = useState("");
  //流程图右键「运行单元操作」的确认弹窗：最大计算时间 + 输入参数预览
  const [runPartConfirmData, setRunPartConfirmData] = useState<any>(null);
  const [runPartMaxWait, setRunPartMaxWait] = useState<number | null>(30);
  const [refreshDesVariable, setRefreshDesVariable] = useState<number>(0);
  const [expandedJobsVariable, setExpandedJobsVariable] = useState<number>(0);
  const [creatDesNameVariable, setCreatDesNameVariable] = useState(null);
  const [creatDesName, setCreatDesName] = useState("");
  const [selectCreatButton,setSelectCreatButton] = useState("design");  //design,real
  const [upTaskNameVariable, setUpTaskNameVariable] = useState(false);
  const closeErrorNoticeRef = useRef<(() => void) | null>(null);
  // const [savedCurTaskJson,setSavedCurTaskJson] = useState(null);
  const [selectGroup,setSelectGroup] = useState(null);
  const [needSaveTaskVariable, setNeedSaveTaskVariable] = useState<number>(0);
  //标记是否有任务保存（updateJob）正在进行：计算轮询刷新任务树前需等待保存完成，
  //否则网络慢时会用保存前的旧数据覆盖刚保存的树（如 S-16 联动 T-106 的更新被冲掉）
  const saveTaskInFlightRef = useRef(false);
  const errorNoticeContextRef = useRef<{
    close: () => void;
    validInfo: any;
    jsonData: any;
    notificationKey: string;
  } | null>(null);

  const stateParams = useParams<{ k: string; f: string; j: string }>();
  const allItems = (jsonData?.nodeDataArray || []).filter(
    (item: any) => !item.isGroup && item.elementName && item.nodeName.trim() !== "",
  );
  const allItemNames = allItems.map((item: any) => item.nodeName);
  const isAllSelected = selectedElements.length === allItemNames.length && allItemNames.length > 0;
  const isIndeterminate =
    selectedElements.length > 0 && selectedElements.length < allItemNames.length;
  
  useEffect(() => {
    if (stateParams) {
      if (selectButton === "计算任务") {
        queryTask();
      } 
      else if (selectButton === "设计值") 
      {
        //关闭报错弹窗
        if (closeErrorNoticeRef.current) 
        {
          closeErrorNoticeRef.current();
          closeErrorNoticeRef.current = null; // 清空，避免重复关闭
        }
      }
      else if(selectButton === "分组")
      {
      }
    }
  }, [stateParams, selectButton]);

  useEffect(() => {
    if (queryTaskVariable > 0) 
    {
      //查询前先取消选中
      setSelectedItem(null);

      queryTask();
    }
  }, [queryTaskVariable]);

  useEffect(() => {
    if (selectButton && saveTaskVariable > 0) {
      if (selectButton === "计算任务") {
        if (selectedItem) {
          saveTask("save", false);
        } else {
          messageApi.open({
            type: "error",
            content: "请选择要保存的计算任务",
          });
        }
      } else if (selectButton === "设计值") {
      }
    }
  }, [saveTaskVariable]);

  useEffect(() => {
    if (openImportPageVariable > 0 && selectedItem) 
    {
      queryDes();
      setImportDataByTree({key:selectedItem.type==="element"?"importElement":"importStream",node:selectedItem,selectJobId:null,selectDesId:null});
      setSelectImportButton("task");
      setImportVariable(true);
    }
  }, [openImportPageVariable]);

  useEffect(() => {
    if (selectedNodeByFlow) {
      setSelectedItem(selectedNodeByFlow);
    }
  }, [selectedNodeByFlow]);

  useEffect(() => {
    if (taskList && selectedItem) 
    {
      let jobId = selectedItem.job_id;
      let selectTask = taskList.find((item) => item.job_id === jobId);
      if (selectTask) {
        if (selectTask.elements.length > 0 || selectTask.streams.length > 0) {
          //处理newJsonData
          let linkDataArray = selectTask.streams.map((obj) => obj["data"]);
          let typeDataArray = selectTask.elements.map((obj) => obj["children"]);
          let nodeDataArray = typeDataArray.flat().map((obj) => obj["data"]);

          let upJsonData = structuredClone(jsonData);
          for (let i = 0; i < upJsonData.linkDataArray.length; i++) {
            let key = upJsonData.linkDataArray[i].key;
            upJsonData.linkDataArray[i] =
              linkDataArray.find((item) => item.key === key) ?? upJsonData.linkDataArray[i];
          }
          for (let i = 0; i < upJsonData.nodeDataArray.length; i++) {
            let key = upJsonData.nodeDataArray[i].key;
            upJsonData.nodeDataArray[i] =
              nodeDataArray.find((item) => item.key === key) ?? upJsonData.nodeDataArray[i];
          }

          if (newJsonData) {
            if (!isEqual(newJsonData, upJsonData)) {
              setNewJsonData(upJsonData);
            }
          } else {
            setNewJsonData(upJsonData);
          }
        }
      }
      setTaskListFunc(taskList);
      setSelectedItemFunc(selectedItem);
      setJobId(jobId);

      // if(selectedItem.type==="job")
      // {
      //   // //关闭报错弹窗
      //   // if (closeErrorNoticeRef.current) 
      //   // {
      //   //   closeErrorNoticeRef.current();
      //   //   closeErrorNoticeRef.current = null; // 清空，避免重复关闭
      //   // }
      // }
      
      // //记录原始数据
      // if (selectTask && selectedItem.type==="job") 
      // {
      //   if(selectTask.elements.length>0 || selectTask.streams.length>0)
      //   {
      //     setSavedCurTaskJson(selectTask);
      //   }
      // }
    }
    else
    {
      //关闭报错弹窗
      if (closeErrorNoticeRef.current) 
      {
        closeErrorNoticeRef.current();
        closeErrorNoticeRef.current = null; // 清空，避免重复关闭
      }
    }
  }, [taskList, selectedItem]);

  useEffect(() => 
  {
    let isRunQueryAllSubJobsToFlow = false;
    if(selectedItemRef.current && selectedItem)
    {
      if(selectedItemRef.current.job_id!==selectedItem.job_id) //任务id改变，代表切换任务
      {
        queryAllSubJobsToFlowVariable.current = false;
        isRunQueryAllSubJobsToFlow = true;
      }
    }

    selectedItemRef.current = selectedItem;

    if(isRunQueryAllSubJobsToFlow)
    {
      queryAllSubJobsToFlow(selectedItem.job_id,false);
    }
  }, [selectedItem]);

  useEffect(() => 
  {
    if(queryAllSubJobsToFlowValue)
    {
      if (queryAllSubJobsToFlowValue.variable > 0) 
      {
        queryAllSubJobsToFlow(queryAllSubJobsToFlowValue.taskId,queryAllSubJobsToFlowValue.isNeedQueryTask);
      }
    }
  }, [queryAllSubJobsToFlowValue?.variable]);

  useEffect(() => 
  {
    if (!pendingJobIdRef.current || !pendingResolveRef.current) return;
    const job = taskList.find(item => item.job_id === pendingJobIdRef.current);
    if (job && (job.elements.length > 0 || job.streams.length > 0)) 
    {
      pendingResolveRef.current();
      pendingJobIdRef.current = null;
      pendingResolveRef.current = null;
    }
  }, [taskList]);

  useEffect(() => 
  {
    taskListRef.current = taskList;
  }, [taskList]);

  useEffect(() => 
  {
    if (pendingSaveRef.current && newJsonData) {
      pendingSaveRef.current = false;
      saveTask("save", false,false,"导入");
    }
  }, [newJsonData,pendingSaveRef.current]);

  useEffect(() => 
  {
    queryDes();
  },[]);

  useEffect(() => 
  {
    if(newJsonData && newTreeData)
    {
      refreshErrorNotice();
    }
  },[newJsonData]); 


  useEffect(() => 
  {
    //关闭报错弹窗
    if (closeErrorNoticeRef.current) 
    {
      closeErrorNoticeRef.current();
      closeErrorNoticeRef.current = null; // 清空，避免重复关闭
    }
  },[taskListVariable]);

  useEffect(() => 
  {
    if(readonly)
    {
      setSelectGroup(null);
      setTaskListSelectGroup(null);
    }
  },[readonly]); 

  useEffect(() => 
  {
    if(runPartTaskByDiagram)
    {
      if(runPartTaskByDiagram.variable>0 && runPartTaskByDiagram.nodeData)
      {
        if(selectedItem && selectedItem?.job_id)
        {
          //仅计算即可
          let selectNode = 
          {
            "type":"element",
            "job_id":selectedItem.job_id,
            "job_name":selectedItem.job_name,
            "category":typeMap3[runPartTaskByDiagram.nodeData.type],
            "item_name":runPartTaskByDiagram.nodeData.nodeName,
            "path":[selectedItem.job_name,"单元操作",typeMap3[runPartTaskByDiagram.nodeData.type],runPartTaskByDiagram.nodeData.nodeName],
            "data":runPartTaskByDiagram.nodeData
          };
          //先弹出确认框（最大计算时间 + 输入参数预览），确认后再计算
          setRunPartMaxWait(30);
          setRunPartConfirmData({selectNode:selectNode});
        }
        else
        {
          //先创建任务后计算（若此时创建任务没有名称）

          // //或直接报错
          // messageApi.open({
          //   type: "error",
          //   content: "请选择计算任务",
          // });

          let selectNode = 
          {
            "type":"element",
            "job_id":null,
            "job_name":null,
            "category":typeMap3[runPartTaskByDiagram.nodeData.type],
            "item_name":runPartTaskByDiagram.nodeData.nodeName,
            "path":[null,"单元操作",typeMap3[runPartTaskByDiagram.nodeData.type],runPartTaskByDiagram.nodeData.nodeName],
            "data":runPartTaskByDiagram.nodeData
          };

          //先弹出确认框（最大计算时间 + 输入参数预览），确认后再进入创建任务流程
          setRunPartMaxWait(30);
          setRunPartConfirmData({selectNode:selectNode});
        }
      }
    }
  }, [runPartTaskByDiagram?.variable]);

  const queryTask = () => 
  {
    // let token = userInfo.access_token;
    // const projectId = stateParams.k;
    const flowId = stateParams.f;
    jobs({ page: 1, perPage: 1000, flow_id: flowId }, userInfo.access_token).then(async (res) => {
      if (res.status === 200) {
        let tasks = res.data.data;
        buildTaskList(tasks);
      } else {
        setTaskList([]);
        setAlreadyTaskIds([]);
        messageApi.open({
          type: "error",
          content: `jobs查询失败：${res.status}`,
        });
      }
    });
  };

  const queryDes = async () =>
  {
    let token = userInfo.access_token;
    const projectId = stateParams.k;
    const flowId = stateParams.f;
    let res = await designValue({flow_id:flowId },userInfo.access_token)
    {
      if (res.status === 200) 
      {
        let dess = res.data;
        setDesList(dess);
      } 
      else 
      {
        setDesList([]);
        messageApi.open
        ({
          type: "error",
          content: `designValue查询失败：${res.status}`,
        });
      }
    }
  }

  const queryDesById = async (id) =>
  {
    let token = userInfo.access_token;
    const projectId = stateParams.k;
    const flowId = stateParams.f;
    let res = await getDesignValue(id,userInfo.access_token)
    {
      if (res.status === 200) 
      {
        let des = res.data;
        return des;
      } 
      else 
      {
        messageApi.open
        ({
          type: "error",
          content: `getDesignValue查询失败：${res.status}`,
        });
        return null;
      }
    }
  }

  //创建任务，保存任务，创建设计值
  const saveTask = async (type: string, isRunning: boolean,isDesign?:boolean,messageType?:string,isCopy?:boolean,creatTaskNameVariable?:any,maxWaitMinutes?:number) => 
  {
    let taskName = "";
    let input;
    let desData;
    const token = userInfo.access_token;

    if (type === "creat") 
    {
      if(isDesign)
      {
        //设计值
        // taskName = `设计值${desList.length + 1}`;
        taskName = creatDesName;
        desData = 
        {
          flow_id:stateParams.f,
          type:creatDesNameVariable?.isRule ? "actual":"design",
          values:buildTaskInput(newJsonData ?? jsonData,allItemNames,state,isRunning ? "True" : "False",taskName,type),
        };
      }
      else
      {
        //任务
        // taskName = `计算任务${taskList.length + 1}`;
        taskName = creatTaskName;

        //判断任务名称是否重复
        let res0 = await jobs({ page: 1, perPage: 1000, flow_id:stateParams.f },token)
        if (res0.status === 200) 
        {
          let tasks = res0.data.data;
          let taskNames = [];
          for(let i=0;i<tasks.length;i++)
          {
            taskNames.push(tasks[i].name);
          }

          if(taskNames.includes(taskName))
          {
            messageApi.open
            ({
              type: "error",
              content: "任务名称重复",
            });
            return false;
          }
        } 
        else
        {
          messageApi.open({
            type: "error",
            content: `jobs查询失败：${res0.status}`,
          });
          return false;
        }

        input = buildTaskInput(isCopy?newJsonData:(!selectedItem?.job_id?jsonData:(flowJsonData??jsonData)),allItemNames,state,isRunning ? "True" : "False",taskName,type,isCopy);
      }
    } 
    else if (type === "save") 
    {
      if(!selectedItem.job_id)
      {
        message.error("请选择要保存的计算任务");
        return false;
      }
      taskName = selectedItem.job_name;

      if(creatTaskName!="")
      {
        taskName = creatTaskName;
      }
      input = buildTaskInput(newJsonData ?? jsonData,allItemNames,state,isRunning ? "True" : "False",taskName,type);
    }
    else if(type==="run")
    {
      taskName = selectedItem.job_name;

      input = buildTaskInput(newJsonData ?? jsonData,allItemNames,state,"True",taskName,type);
      input.id = selectedItem.job_id;
      input["mix_input"]["max_wait_minutes"] = maxWaitMinutes ?? 30; //最大计算时间(分)
    }
    if (!isDesign) //此时仅创建，不涉及计算，暂时不需要校验数据合法性
    {
      if (type === "creat") 
      {

        //如果编辑模式下创建前先执行保存（保存图）
        if(readonly===false)
        {
          saveDiagram();
        }

        //判断名称重复
        if(new Set(input.mix_input.elements.map(obj => obj["name"])).size !== input.mix_input.elements.map(obj => obj["name"]).length)
        {
          messageApi.open({
            type: "error",
            content: "创建失败：存在相同名称的元件",
            style: { marginTop: "50px" },
          });
          return false;
        }
        if(new Set(input.mix_input.selected_blocks).size !== input.mix_input.selected_blocks.length)
        {
          messageApi.open({
            type: "error",
            content: "创建失败：存在相同名称的元件",
            style: { marginTop: "50px" },
          });
          return false;
        }
        if(new Set(input.mix_input.streams.map(obj => obj["name"])).size !== input.mix_input.streams.map(obj => obj["name"]).length)
        {
          messageApi.open({
            type: "error",
            content: "创建失败：存在相同名称的流股",
            style: { marginTop: "50px" },
          });
          return false;
        }

        const res = await simulation(input, token);
        if (res.status === 200) 
        {
          messageApi.open({
            type: "success",
            content:"创建成功",
            style: { marginTop: "50px" },
          });

          //创建成功触发刷新
          queryTask();

          //强制切换为只读模式
          setReadonly(true);

          //判断是否需要执行单元件计算
          if(creatTaskNameVariable)
          {
            if(creatTaskNameVariable.isNeedRunPartElement)
            {
              let needRunPartElementData = structuredClone(creatTaskNameVariable.needRunPartElementData);
              needRunPartElementData.job_id = res.data.id;
              needRunPartElementData.job_name = res.data.name;
              needRunPartElementData.path[0] = res.data.name;

              //运行计算（无需await）
              runPartTask(needRunPartElementData, creatTaskNameVariable.maxWaitMinutes);
            }
          }

          return true;
        } 
        else 
        {
          messageApi.open({
            type: "error",
            content:`创建失败：${res.status}`,
            style: { marginTop: "50px" },
          });
          return false;
        }

      } else if (type === "save") {
        saveTaskInFlightRef.current = true;
        let res;
        try {
          res = await updateJob(selectedItem.job_id, input, token);
        } finally {
          saveTaskInFlightRef.current = false;
        }
        if (res.status === 200) {
          message.success(`${messageType??"保存"}成功`);

          // setSavedCurTaskJson(taskList.find((item) => item.job_id === selectedItem.job_id));
          setNeedSaveTaskVariable(needSaveTaskVariable+1);

          //保存成功触发刷新
          queryTask();

          setButtonAbled(true);
          return true;
        } else {
          message.error(`${messageType??"保存"}失败：${res.status}`);

          setButtonAbled(true);

          return false;
        }
      } 
      else if(type==="run")
      {
        const validInfo = validateInput(input.mix_input);
        if (validInfo === "ok")
        // if (true)
        {
          const res = await simulation(input, token);
          if (res.status === 200) 
          {
            message.success("开始计算");
            
            //提交用户任务信息，便于后续统计（全流程任务无 subjob_id）
            userJobInteraction({
              user_id: userInfo.id,
              username: userInfo.username,
              job_id: selectedItem.job_id,
            }).catch((e) => console.error("提交用户任务信息失败", e));

            setLoadingVariable(false);

            //新流股动画
            let res2 = await queryAllSubJobsToFlow(selectedItem.job_id,true);

            // //流股动画
            // await changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),true);

            // //每五秒查询一次计算结果
            // let successQuerySubjobs = false;
            // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    
            // while(!successQuerySubjobs)
            // {
            //   const startTime = Date.now();
            //   let res2 = await getJob(selectedItem.job_id,token);
            //   if (res2.status === 200) 
            //   {
            //     let curJobData = res2.data;
            //     if(curJobData)
            //     {
            //       if(curJobData.status==="done"||curJobData.status==="error")
            //       {
            //         successQuerySubjobs = true;

            //         if(curJobData.status==="done")
            //         {
            //           message.success("计算成功");
            //           //计算成功触发刷新
            //           await queryTask();
  
            //           //流股动画
            //           changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),false);
            //         }
            //         else if(curJobData.status==="error")
            //         {
            //           message.error("计算失败");
  
            //           //流股动画
            //           changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),false);
            //         }
            //       }
            //     }
            //     else
            //     {
            //       message.error(`未找到计算任务：${selectedItem.job_id}`);
            //       successQuerySubjobs = true;
  
            //       //流股动画
            //       changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),false);
            //     }
            //   }
            //   else 
            //   {
            //     message.error(`查询计算任务失败：${res2.status}`);
            //     successQuerySubjobs = true;
            //     // setLoadingVariable(false);
  
            //     //流股动画
            //     setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:false});
            //   }
            //   const elapsed = Date.now() - startTime;
            //   await delay(Math.max(0, 5000 - elapsed));
            // }

            // // //判断计算完成后
            // // await changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),false);
          } 
          else 
          {
            message.error(`开始计算失败：${res.status}`);
          }
          setButtonAbled(true);
        }
        else 
        {
          //校验不通过
          setLoadingVariable(false);
          
          let openErrorNotificationJsonData = newJsonData ?? jsonData;
          openErrorNotificationJsonData.job_id = selectedItem.job_id;
          openErrorNotificationJsonData.job_name = selectedItem.job_name;

          const closeFn = openErrorNotification(
            validInfo,
            notificationApi,
            notificationKey,
            setSelectedItem,
            openErrorNotificationJsonData,
            selectElement,
            setIsNowNeedOpenPramDrawer,
          );
          if (closeFn) 
          {
            closeErrorNoticeRef.current = closeFn;
            errorNoticeContextRef.current = {
              close: closeFn,
              validInfo: validInfo,
              jsonData: openErrorNotificationJsonData,
              notificationKey: notificationKey,
            };
          }
        }
      }
      else {
        message.error(`函数类型非法：${type}`);
        setButtonAbled(true);
      }
    } else {
      //设计值
      if (type === "creat") 
      {
        const res = await createDesignValue(desData,token)
        if (res.status === 200) {
          message.success("创建成功");
          setSelectButton("设计值");
          setRefreshDesVariable(refreshDesVariable + 1);
        } else {
          message.error(`创建失败：${res.status}`);
        }
      }
    }

    return true;
  };

  //流程图右键「运行单元操作」确认后：已有任务直接计算，未选任务则先创建任务再计算
  const confirmRunPartTask = () => {
    const selectNode = runPartConfirmData?.selectNode;
    if (!selectNode) return;
    const maxWaitMinutes = runPartMaxWait ?? 30;
    setRunPartConfirmData(null);
    if (selectNode.job_id) {
      runPartTask(selectNode, maxWaitMinutes);
    } else {
      setCreatTaskNameVariable({
        open: true,
        isCopy: false,
        isNeedRunPartElement: true,
        needRunPartElementData: selectNode,
        maxWaitMinutes: maxWaitMinutes,
      });
    }
  };

  //运行计算(单个元件)
  const runPartTask = async(selectNode, maxWaitMinutes?: number) =>
  {
    let input = buildTaskInput(newJsonData ?? jsonData,[selectNode.item_name],state,"True",selectNode.item_name,"creat");
    input["mix_input"]["max_wait_minutes"] = maxWaitMinutes ?? 30; //最大计算时间(分)
    // 校验数据合法性
    const validInfo = validateInput(input["mix_input"]);
    if (validInfo === "ok") 
    // if(true)
    {
      const subdata=
      {
        job_id:selectNode.job_id,
        job_type:'simulation',
        name:selectNode.item_name,
        cal:'True',
        type:"single",  //单个元件计算
        input:input["mix_input"],
        in_streams:input["mix_input"].streams.filter((s:any)=>s.type==='进料').map((i:any)=>i.name),
        out_streams:input["mix_input"].streams.filter((s:any)=>s.type==='出料').map((i:any)=>i.name),
        internal_streams:input["mix_input"].streams.filter((s:any)=>s.type==='内部').map((i:any)=>i.name),
      }

      const token = userInfo.access_token;

      //开始计算前先查询一下，避免重复

      const res = await subjobs(subdata, token);
      if (res.status === 200) 
      {
        message.success("开始计算");

        //提交用户任务信息，便于后续统计（单元件运行单元操作，subjob_id 为本次子任务 id）
        userJobInteraction({
          user_id: userInfo.id,
          username: userInfo.username,
          job_id: selectNode.job_id,
          subjob_id: res.data?.id,
        }).catch((e) => console.error("提交用户任务信息失败", e));

        //元件居中且缩放100%
        setSearchElementName({name:selectNode.item_name,type:"node"});
        setLoadingVariable(false);

        //新流股动画
        let res2 = await queryAllSubJobsToFlow(selectNode.job_id,true);

        // //流股动画
        // await changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),true);

        // //每五秒查询一次计算结果
        // let subId = res.data.id;
        // let successQuerySubjobs = false;
        // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

        // while(!successQuerySubjobs)
        // {
        //   const startTime = Date.now();

        //   let res2 = await getSubjob(subId);
        //   if (res2.status === 200) 
        //   {
        //     // let subData = res2.data.find(item=>item.id===subId);
        //     let subData = res2.data;
        //     if(subData)
        //     {
        //       if(subData.status==="done"||subData.status==="error")
        //       {
        //         successQuerySubjobs = true;
        //         setLoadingVariable(false);
        //         //流股动画
        //         await changeLinkFlow(input["mix_input"].streams.map(obj => obj["name"]),false);

        //         if(subData.status==="done")
        //         {
        //           message.success("计算成功");
        //           //计算成功触发刷新
        //           queryTask();
        //         }
        //         else if(subData.status==="error")
        //         {
        //           message.error("计算失败");
        //         }
        //       }
        //     }
        //     else
        //     {
        //       message.error(`未找到计算任务：${subId}`);
        //       successQuerySubjobs = true;
        //       setLoadingVariable(false);
        //     }
        //   }
        //   else 
        //   {
        //     message.error(`查询计算任务失败：${res2.status}`);
        //     successQuerySubjobs = true;
        //     setLoadingVariable(false);
        //   }
        //   const elapsed = Date.now() - startTime;
        //   await delay(Math.max(0, 5000 - elapsed));
        // }
      } 
      else 
      {
        message.error(`开始计算失败：${res.status}`);
        setLoadingVariable(false);
      }
    } 
    else 
    {
      //校验不通过
      setLoadingVariable(false);

      let openErrorNotificationJsonData = newJsonData ?? jsonData;
      openErrorNotificationJsonData.job_id = selectNode.job_id;
      openErrorNotificationJsonData.job_name = selectNode.job_name;
      const closeFn = openErrorNotification(
        validInfo,
        notificationApi,
        notificationKey,
        setSelectedItem,
        openErrorNotificationJsonData,
        selectElement,
        setIsNowNeedOpenPramDrawer,
      );
      if (closeFn) 
      {
        closeErrorNoticeRef.current = closeFn;
        errorNoticeContextRef.current = {
          close: closeFn,
          validInfo: validInfo,
          jsonData: openErrorNotificationJsonData,
          notificationKey: notificationKey,
        };
      }
    }
  };

  /**
   * 运行组合任务：以该组合最近一次运行记录的输入推导其包含的单元(nodeName)清单，
   * 按当前设计参数重新构建输入，提交 type=multi 的子任务（同名新增一次运行记录），
   * 随后轮询直至计算完成并刷新任务树
   */
  const runComboTask = async (
    jobId: number,
    name: string,
    runs: any[],
    maxWaitMinutes?: number,
    lastSubjobId?: number | null,
  ) => {
    setLoadingVariable(true);
    const token = userInfo.access_token;

    //刷新该任务的组合结果列表（任务树按 subJobs 按名称聚合渲染，刷新后新增的运行记录即可出现）
    const refreshComboSubJobs = async () => {
      try {
        const freshRes = await getSubjobs({ job_id: jobId });
        if (freshRes.status === 200) {
          const newSubJobs = freshRes.data.filter((item: any) => item.type === "multi");
          setTaskList((prev: any) =>
            prev.map((item: any) =>
              item.job_id === jobId ? { ...item, subJobs: newSubJobs } : item,
            ),
          );
        }
      } catch (e) {
        console.error("刷新组合结果列表失败:", e);
      }
    };

    //1.以最近一次运行记录为参照，获取该组合包含的单元清单
    let elementNames: string[] = [];
    try {
      const latest = [...(runs || [])].sort(
        (a: any, b: any) => Number(b.id) - Number(a.id),
      )[0];
      if (latest && latest.id) {
        const res = await getSubjob(latest.id);
        if (res.status === 200 && res.data) {
          let rawInput: any = res.data.input;
          if (typeof rawInput === "string") {
            try {
              rawInput = JSON.parse(rawInput);
            } catch (e) {
              rawInput = null;
            }
          }
          const mix = (rawInput && rawInput.mix_input) || rawInput || {};
          elementNames = (mix.elements || [])
            .map((el: any) => el && el.name)
            .filter(Boolean);
        }
      }
    } catch (err) {
      console.error("读取组合任务输入失败:", err);
    }

    if (elementNames.length === 0) {
      message.error("无法获取该组合的单元清单，请先在画布上发起组合计算");
      setLoadingVariable(false);
      return;
    }

    //2.按当前设计参数重新构建该组合的输入并提交计算
    const input = buildTaskInput(
      newJsonData ?? jsonData,
      elementNames,
      state,
      "True",
      name,
      "creat",
    );
    input["mix_input"]["max_wait_minutes"] = maxWaitMinutes ?? 30; //最大计算时间(分)
    //基于过往组合计算结果：选择后与 elements/streams 同级携带 last_subjob_id；未选择时不带该参数
    if (lastSubjobId !== null && lastSubjobId !== undefined) {
      input["mix_input"]["last_subjob_id"] = lastSubjobId;
    }

    //校验数据合法性
    const validInfo = validateInput(input["mix_input"]);
    if (validInfo === "ok") {
      const subdata = {
        job_id: jobId,
        job_type: "simulation",
        name: name,
        cal: "True",
        type: "multi", //组合元件计算
        input: input["mix_input"],
        in_streams: input["mix_input"].streams
          .filter((s: any) => s.type === "进料")
          .map((i: any) => i.name),
        out_streams: input["mix_input"].streams
          .filter((s: any) => s.type === "出料")
          .map((i: any) => i.name),
        internal_streams: input["mix_input"].streams
          .filter((s: any) => s.type === "内部")
          .map((i: any) => i.name),
      };

      const res = await subjobs(subdata, token);
      if (res.status === 200) {
        message.success("开始计算");
        setLoadingVariable(false);

        //提交用户任务信息，便于后续统计（运行组合任务，subjob_id 为本次子任务 id）
        userJobInteraction({
          user_id: userInfo.id,
          username: userInfo.username,
          job_id: jobId,
          subjob_id: res.data?.id,
        }).catch((e) => console.error("提交用户任务信息失败", e));

        //流股动画：立即以该组合包含的元件为准开启（与画布上首次发起组合计算一致，按元件找相邻流股，进料/出料/内部都不漏），
        //后续轮询不带元件时靠画布缓存的元件 key 继续流动，计算结束由轮询把 flowEnabled 置为 false 停止
        setChangeLinkFlowValue?.({
          flowEnabled: true,
          elementNames: [...elementNames],
        });

        //立即刷新该任务的组合结果列表：新提交的这次运行（还在计算中）也要马上出现在同名组合节点下，不必等计算完成
        await refreshComboSubJobs();

        //轮询子任务直至完成（完成后会刷新任务树与结果抽屉）
        await queryAllSubJobsToFlow(jobId, true);

        //计算结束后再刷新一次，确保最新结果挂在同名节点下
        await refreshComboSubJobs();
      } else {
        message.error(`开始计算失败：${res.status}`);
        setLoadingVariable(false);
      }
    } else {
      //校验不通过
      setLoadingVariable(false);

      let openErrorNotificationJsonData = newJsonData ?? jsonData;
      openErrorNotificationJsonData.job_id = jobId;
      const closeFn = openErrorNotification(
        validInfo,
        notificationApi,
        notificationKey,
        setSelectedItem,
        openErrorNotificationJsonData,
        selectElement,
        setIsNowNeedOpenPramDrawer,
      );
      if (closeFn) {
        closeErrorNoticeRef.current = closeFn;
        errorNoticeContextRef.current = {
          close: closeFn,
          validInfo: validInfo,
          jsonData: openErrorNotificationJsonData,
          notificationKey: notificationKey,
        };
      }
    }
  };

  /**
   * 读取某个 subjob 输入（可能含非法 NaN）中包含的元件与流股
   */
  const fetchSubjobMix = async (subjobId: number) => {
    const res = await getSubjob(subjobId);
    if (res.status !== 200 || !res.data) return { elements: [], streams: [] };
    let rawInput: any = res.data.input;
    if (typeof rawInput === "string") {
      try {
        rawInput = JSON.parse(rawInput);
      } catch (e) {
        rawInput = null;
      }
    }
    const mix = (rawInput && rawInput.mix_input) || rawInput || {};
    return { elements: mix.elements || [], streams: mix.streams || [] };
  };

  /**
   * 将来源（input 格式）中命中名称范围的元件/流股覆盖到目标任务并保存
   * （allowElementNames/allowStreamNames 为 null 表示不限制，仅按目标任务中已存在的同名项替换）
   */
  const applyMixToTargetJob = async (
    jobId: number,
    jobName: string,
    sourceElements: any[],
    sourceStreams: any[],
    allowElementNames?: Set<string> | null,
    allowStreamNames?: Set<string> | null,
  ) => {
    setLoadingVariable(true);
    const token = userInfo.access_token;
    try {
      const hasSourceElement = sourceElements && sourceElements.length > 0;
      const hasSourceStream = sourceStreams && sourceStreams.length > 0;
      if (!hasSourceElement && !hasSourceStream) {
        message.error("被导入的数据中没有可导入的元件/流股数据");
        return;
      }
      //以当前设计重建任务输入，将命中的元件/流股按名称逐个覆盖
      const input = buildTaskInput(
        newJsonData ?? jsonData,
        allItemNames,
        state,
        "False",
        jobName,
        "save",
      );
      const newInput = JSON.parse(input["input"]);
      let elementCount = 0;
      (sourceElements || []).forEach((el: any) => {
        if (!el || !el.name) return;
        if (allowElementNames && !allowElementNames.has(el.name)) return;
        const idx = newInput.elements.findIndex(
          (item: any) => item && item.name === el.name,
        );
        if (idx !== -1) {
          newInput.elements[idx] = el;
          elementCount++;
        }
      });
      let streamCount = 0;
      (sourceStreams || []).forEach((st: any) => {
        if (!st || !st.name) return;
        if (allowStreamNames && !allowStreamNames.has(st.name)) return;
        const idx = newInput.streams.findIndex(
          (item: any) => item && item.name === st.name,
        );
        if (idx !== -1) {
          newInput.streams[idx] = st;
          streamCount++;
        }
      });
      if (elementCount === 0 && streamCount === 0) {
        message.error("被导入的元件/流股与当前任务不一致，未导入任何数据");
        return;
      }
      input["input"] = JSON.stringify(newInput);

      //保存到后端并刷新
      const upd = await updateJob(jobId, input, token);
      if (upd.status === 200) {
        const parts: string[] = [];
        if (elementCount > 0) parts.push(`${elementCount} 个元件`);
        if (streamCount > 0) parts.push(`${streamCount} 条流股`);
        message.success(`导入成功，已更新 ${parts.join("、")}参数`);
        queryTask();
      } else {
        message.error(`导入失败：${upd.status}`);
      }
    } catch (err) {
      console.error("导入组合任务数据失败:", err);
      message.error("导入失败，请重试");
    } finally {
      setLoadingVariable(false);
    }
  };

  /**
   * 组合计算来源导入：把所选组合运行中包含的元件与流股覆盖到目标任务并保存
   */
  const importComboSubJobData = async (
    jobId: number,
    jobName: string,
    subjobId: number,
  ) => {
    const mix = await fetchSubjobMix(subjobId);
    if (mix.elements.length === 0 && mix.streams.length === 0) {
      message.error("该组合运行中没有可导入的元件/流股数据");
      return;
    }
    await applyMixToTargetJob(
      jobId,
      jobName,
      mix.elements,
      mix.streams,
      null,
      null,
    );
  };

  /**
   * 以该组合最近一次运行界定"组合内元件/流股"名称集合（用于 计算任务/设计值/实际值 来源只覆盖组合内元件与流股）
   */
  const fetchLatestComboMixNames = async (runs: any[]) => {
    const empty = {
      elementNames: new Set<string>(),
      streamNames: new Set<string>(),
    };
    if (!runs || runs.length === 0) return empty;
    const latest = runs.reduce((a: any, b: any) =>
      Number(b.id) > Number(a.id) ? b : a,
    );
    const mix = await fetchSubjobMix(latest.id);
    const elementNames = new Set<string>();
    (mix.elements || []).forEach((el: any) => {
      if (el && typeof el.name === "string" && el.name !== "") {
        elementNames.add(el.name);
      }
    });
    const streamNames = new Set<string>();
    (mix.streams || []).forEach((st: any) => {
      if (st && typeof st.name === "string" && st.name !== "") {
        streamNames.add(st.name);
      }
    });
    return { elementNames, streamNames };
  };

  const queryAllSubJobsToFlow = async(taskId,isNeedQueryTask?) =>
  {
    if(queryAllSubJobsToFlowVariable.current===false) //判断能否继续执行，该函数需要避免重复调用
    {
      queryAllSubJobsToFlowVariable.current = true;

      if(selectedItemRef.current.job_id===taskId) //若当前所选的任务与正在计算的任务相同则继续
      {
        //每五秒查询一次计算结果
        let successQuerySubjobs = false;
        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

        while( (!successQuerySubjobs) && (queryAllSubJobsToFlowVariable.current===true) )
        {
          const startTime = Date.now();

          let newChangeLinkFlowValue = 
          {
            flowEnabled:false,
            nodeNames:[],
            linkNames:[]
          };

          let res;
          try 
          {
            res = await getSubjobs({job_id:taskId});
          } 
          catch (e:any) 
          {
            //请求异常（如404）打印到控制台，干净地停止轮询，避免异常冒泡
            console.error(`查询子任务失败：${e?.message || e}`);
            successQuerySubjobs = true;
            queryAllSubJobsToFlowVariable.current = false;
            break;
          }
          if (res.status === 200) 
          {
            let subDatas = res.data.filter(item=>item.status!=="done" && item.status!=="error");
            if(subDatas.length>0)
            {
              //有正在计算的任务
              let newNodeNames = [];
              let newLinkNames = [];
              for(let i=0;i<subDatas.length;i++)
              {
                let newNodeName = subDatas[i].name;
                if(!newNodeNames.includes(newNodeName))
                {
                  newNodeNames.push(newNodeName);
                }

                let newInLinksNames = subDatas[i].in_streams;
                let newOutLinksNames = subDatas[i].out_streams;
                let newInternalLinksNames = subDatas[i].internal_streams;
                for(let j=0;j<newInLinksNames.length;j++)
                {
                  let newLinkName = newInLinksNames[j];
                  if(!newLinkNames.includes(newLinkName))
                  {
                    newLinkNames.push(newLinkName);
                  }
                }
                for(let j=0;j<newOutLinksNames.length;j++)
                {
                  let newLinkName = newOutLinksNames[j];
                  if(!newLinkNames.includes(newLinkName))
                  {
                    newLinkNames.push(newLinkName);
                  }
                }
                if(newInternalLinksNames)
                {
                  for(let j=0;j<newInternalLinksNames.length;j++)
                  {
                    let newLinkName = newInternalLinksNames[j];
                    if(!newLinkNames.includes(newLinkName))
                    {
                      newLinkNames.push(newLinkName);
                    }
                  }
                }
              }

              newChangeLinkFlowValue.flowEnabled = true;
              newChangeLinkFlowValue.nodeNames = newNodeNames;
              newChangeLinkFlowValue.linkNames = newLinkNames;
            }
            else
            {
              //没有正在计算的任务
              //无事发生
            }

            //查询父（全部）计算任务
            const token = userInfo.access_token;
            let res2: any;
            try 
            {
              res2 = await getJob(taskId,token);
            } 
            catch (e:any) 
            {
              //请求异常（如404）打印到控制台，干净地停止轮询，避免异常冒泡
              console.error(`查询父任务失败：${e?.message || e}`);
              successQuerySubjobs = true;
              queryAllSubJobsToFlowVariable.current = false;
              break;
            }
            if (res2.status === 200) 
            {
              let curJobData = res2.data;
              if(curJobData)
              {
                if(curJobData.status==="done"||curJobData.status==="error"||curJobData.status==="unstart")
                {
                  //没有正在计算的任务
                  //无事发生
                }
                else
                {
                  
                  //有正在计算的任务
                  let newNodeNames = newChangeLinkFlowValue.nodeNames;
                  let newLinkNames = newChangeLinkFlowValue.linkNames;

                  let input = taskList.find(item=>item.job_id===taskId).input;
                  let inputElements = input.elements.map(obj => obj["name"]);
                  let inputStreams = input.streams.map(obj => obj["name"]);
                  
                  for(let i=0;i<inputElements.length;i++)
                  {
                    let newNodeName = inputElements[i];
                    if(!newNodeNames.includes(newNodeName))
                    {
                      newNodeNames.push(newNodeName);
                    }
                  }
                  for(let i=0;i<inputStreams.length;i++)
                  {
                    let newLinkName = inputStreams[i];
                    if(!newLinkNames.includes(newLinkName))
                    {
                      newLinkNames.push(newLinkName);
                    }
                  }

                  newChangeLinkFlowValue.flowEnabled = true;
                  newChangeLinkFlowValue.nodeNames = newNodeNames;
                  newChangeLinkFlowValue.linkNames = newLinkNames;
                }
              }
            }
            else 
            {
              console.error(`查询计算任务失败：${res2.status}`);
              successQuerySubjobs = true;
            }
          
            if(newChangeLinkFlowValue.flowEnabled===false)
            {
              //没有任何正在计算的任务，可以停止循环查询
              successQuerySubjobs = true;
              queryAllSubJobsToFlowVariable.current = false;

              //刷新任务树前，先等待可能正在进行中的保存（updateJob）完成（最多等10秒），
              //避免拉到保存前的旧任务数据，把刚保存的树（如 S-16 联动 T-106 的更新）覆盖回旧值
              for (let i = 0; i < 50 && saveTaskInFlightRef.current; i++) {
                await delay(200);
              }

              if(isNeedQueryTask===true)
              {
                //计算成功触发刷新
                message.success("计算完成");
                queryTask();

                //刷新结果抽屉
                setRefreshResVariable();
              }
              //计算成功触发刷新
              queryTask();
            }

            //更改流股动画
            setChangeLinkFlowValue(newChangeLinkFlowValue);
          }
          else 
          {
            console.error(`查询计算任务失败：${res.status}`);
            successQuerySubjobs = true;
          }
          const elapsed = Date.now() - startTime;
          await delay(Math.max(0, 5000 - elapsed));
        }
      }
    }
    return;
  };

  //删除任务
  const deleteTask = async(jobId) =>
  {
    const token = userInfo.access_token;
    let res = await deleteJob(jobId,token)
    if (res.status === 200) 
    {
      message.success("删除成功");

      //取消树的选中,展开
      setExpandedJobsVariable(expandedJobsVariable+1);
      setClearSelectVariable();
      setSelectedItem(null);

      //传值给父页面
      setTaskListFunc([]);
      setSelectedItemFunc({job_id:null,path:[]});
      setJobId(null);
      //清空全部高亮/流动
      clearHigh();

      //删除成功触发刷新
      await queryTask();
    }
    else
    {
      message.error("计算任务删除失败");
    }
  };

  const buildTaskList = async (tasks) => {
    let newTaskLists = [];
    for (let i = 0; i < tasks.length; i++) {
      let newTaskList = {
        job_id: tasks[i].id,
        jobname: tasks[i].name,
        elements: [],
        streams: [],
        input:{},
        subJobs:[],
        groups:[],
      };
      newTaskLists.push(newTaskList);
    }
    setTaskList(newTaskLists);
    setAlreadyTaskIds([]);

    //禁止编辑模式
    if(newTaskLists.length>0)
    {
      setAllowUpDiagrams(false);
    }
  };

  const onClick = (taskId, elementType, elementName, data) => {
    if (elementType === "element") {
      elementType = "node";
    } else if (elementType === "stream") {
      elementType = "link";
    }

    if (data) 
    {
      selectElement(elementType, data);
      //setCloseModalVariable();
    } 
    else 
    {
      selectElement(null, null);
      //setCloseModalVariable();
    }
  };

  /**
   * "其他项目流程"导入来源：加载项目列表
   */
  const loadOtherProjects = async () =>
  {
    try
    {
      setOtherLoading(true);
      const res:any = await projects({ owner_id:userInfo.id, page:1, perPage:1000 }, userInfo.access_token);
      setOtherProjectList(res?.data?.data || []);
    }
    catch(err)
    {
      console.error("获取项目列表失败", err);
      setOtherProjectList([]);
    }
    finally
    {
      setOtherLoading(false);
    }
  };

  /**
   * "其他项目流程"导入来源：选中项目后加载其流程列表
   */
  const loadOtherFlows = async (projectId:any) =>
  {
    try
    {
      setOtherLoading(true);
      const res:any = await flows(projectId, { page:1, perPage:1000 }, userInfo.access_token);
      setOtherFlowList(res?.data?.data || []);
    }
    catch(err)
    {
      console.error("获取项目流程列表失败", err);
      setOtherFlowList([]);
    }
    finally
    {
      setOtherLoading(false);
    }
  };

  /**
   * "其他项目流程"导入来源：选中流程后加载其计算任务（仅计算成功的）
   */
  const loadOtherJobs = async (flowId:any) =>
  {
    try
    {
      setOtherLoading(true);
      const res:any = await jobs({ flow_id:flowId, page:1, perPage:1000 }, userInfo.access_token);
      setOtherJobList((res?.data?.data || []).filter((item:any)=>item.status==="done"));
    }
    catch(err)
    {
      console.error("获取项目任务列表失败", err);
      setOtherJobList([]);
    }
    finally
    {
      setOtherLoading(false);
    }
  };

  const importData = async () =>
  { 
    if(importDataByTree)
    {
      let selectJobId = importDataByTree.selectJobId;
      let selectDesId = importDataByTree.selectDesId;
      //组合计算导入：与单元件/整任务导入共用弹窗与样式；来源可为 计算任务/设计值/实际值/组合计算，
      //导入范围始终为该组合包含的元件与流股（仅按名称覆盖目标任务中的这些项，不影响其他元件/流股）
      if(importDataByTree.key==="importCombo")
      {
        const comboNode:any = importDataByTree.node || {};
        if(selectImportButton==="combo")
        {
          //组合计算来源：导入所选运行中包含的全部元件
          if(!selectDesId)
          {
            messageApi.open({ type:"error", content:"请选择需要导入的组合计算结果" });
            return;
          }
          await importComboSubJobData(comboNode.job_id, comboNode.job_name, selectDesId);
        }
        else
        {
          //计算任务/设计值/实际值来源：以该组合最近一次运行界定"组合内元件/流股"，只覆盖这些元件与流股
          const { elementNames, streamNames } = await fetchLatestComboMixNames(comboNode.runs);
          if(elementNames.size===0 && streamNames.size===0)
          {
            messageApi.open({ type:"error", content:"该组合暂无可用运行数据，无法确定导入范围" });
            return;
          }
          let sourceElements:any[] = [];
          let sourceStreams:any[] = [];
          if(selectImportButton==="task")
          {
            if(!selectJobId)
            {
              messageApi.open({ type:"error", content:"请选择需要导入的计算任务" });
              return;
            }
            const res = await getJob(selectJobId, userInfo.access_token);
            if(res.status===200 && res.data)
            {
              let rawInput:any = res.data.input;
              if(typeof rawInput==="string")
              {
                try{ rawInput = JSON.parse(rawInput); }catch(e){ rawInput = null; }
              }
              const root = (rawInput && rawInput.mix_input) || rawInput || {};
              sourceElements = root.elements || [];
              sourceStreams = root.streams || [];
            }
          }
          else
          {
            //设计值 / 实际值
            if(!selectDesId)
            {
              messageApi.open({ type:"error", content:`请选择需要导入的${selectImportButton==="design"?"设计值":"实际值"}` });
              return;
            }
            const selectDes = await queryDesById(selectDesId);
            if(selectDes && selectDes["values"] && selectDes["values"]["mix_input"])
            {
              sourceElements = selectDes["values"]["mix_input"].elements || [];
              sourceStreams = selectDes["values"]["mix_input"].streams || [];
            }
          }
          if(sourceElements.length===0 && sourceStreams.length===0)
          {
            messageApi.open({ type:"error", content:"被导入的数据中没有元件/流股数据" });
            return;
          }
          await applyMixToTargetJob(
            comboNode.job_id,
            comboNode.job_name,
            sourceElements,
            sourceStreams,
            elementNames,
            streamNames,
          );
        }
        setImportDataByTree(null);
        setImportVariable(false);
        return;
      }
      //其他项目流程来源：选中"其他项目 → 流程 → 计算任务"后，导入该任务输入数据中的元件/流股
      if(selectImportButton==="otherProject")
      {
        if(!otherProjectId)
        {
          messageApi.open({ type:"error", content:"请选择需要导入的项目" });
          return;
        }
        if(!otherFlowId)
        {
          messageApi.open({ type:"error", content:"请选择需要导入的流程" });
          return;
        }
        if(!otherJobId)
        {
          messageApi.open({ type:"error", content:"请选择需要导入的计算任务" });
          return;
        }
        const res:any = await getJob(otherJobId, userInfo.access_token);
        if(res.status!==200 || !res.data)
        {
          messageApi.open({ type:"error", content:"查询被导入的计算任务失败" });
          return;
        }
        let rawInput:any = res.data.input;
        if(typeof rawInput==="string")
        {
          //与结果解析一致：引擎返回的 JSON 文本可能含非法 NaN，解析前统一替换
          try{ rawInput = JSON.parse(rawInput.replace(/NaN/g,"0")); }catch(e){ rawInput = null; }
        }
        const root = (rawInput && rawInput.mix_input) || rawInput || {};
        const sourceElements:any[] = root.elements || [];
        const sourceStreams:any[] = root.streams || [];
        //① 原始数据：其他项目下的该 job 记录（接口原样）
        console.log("[导入数据①原始数据-其他项目] 选中的 job 记录（接口原样）:", {
          projectId:otherProjectId,
          flowId:otherFlowId,
          jobId:otherJobId,
          record:res.data,
        });
        //② 解析后：从原始记录里取出的 mix_input（elements/streams）
        console.log("[导入数据②解析后-其他项目] mix_input 中的 elements/streams:", {
          sourceElements,
          sourceStreams,
        });
        if(sourceElements.length===0 && sourceStreams.length===0)
        {
          messageApi.open({ type:"error", content:"被导入的数据中没有元件/流股数据" });
          return;
        }
        await applyMixToTargetJob(
          importDataByTree.node.job_id,
          importDataByTree.node.job_name,
          sourceElements,
          sourceStreams,
          null,
          null,
        );
        setImportDataByTree(null);
        setImportVariable(false);
        return;
      }
      //单元件导入-运行记录来源：导入当前元件其他次运行任务中的该元件输入数据
      //（弹窗内"运行记录"来源仅单元件导入时出现，选项为 TreeMenu 传回的该元件历史运行 runs）
      if(importDataByTree.key==="importElement" && selectImportButton==="elementRun")
      {
        if(!selectDesId)
        {
          messageApi.open({ type:"error", content:"请选择需要导入的元件任务" });
          return;
        }
        const mix = await fetchSubjobMix(selectDesId);
        const targetName = importDataByTree.node.item_name;
        const targetElement = (mix.elements||[]).find(
          (el:any) => el && el.name===targetName,
        );
        if(!targetElement)
        {
          message.error("该次运行中没有当前元件的输入数据");
          return;
        }
        await applyMixToTargetJob(
          importDataByTree.node.job_id,
          importDataByTree.node.job_name,
          [targetElement],
          [],
          new Set<string>([targetName]),
          new Set<string>(),
        );
        setImportDataByTree(null);
        setImportVariable(false);
        return;
      }
      if(selectImportButton==="task")
      {
        if(selectJobId)
        {
          let importedTask = taskList.find(item=>item.job_id===selectJobId);

          if(importedTask.elements.length===0 && importedTask.streams.length===0)
          {
            //该任务还没有被查询，先执行查询
            pendingJobIdRef.current = selectJobId;
            const waitPromise = new Promise<void>((resolve) => 
            {
              pendingResolveRef.current = resolve;
            });

            setExpandFirstItemVariable({selectTaskName:importedTask.jobname,selectTaskId:selectJobId});
            await waitPromise;
            importedTask = taskListRef.current.find(item=>item.job_id===selectJobId);
          }
          
          //再次判断确保是新数据
          if(importedTask.elements.length>0 || importedTask.streams.length>0)
          {
            //判断导入类型
            let importType = importDataByTree.key;
            if(importType==="importjob")
            {
              //全部导入
              let importedTaskNode = importedTask.elements;
              let importedTaskLink = importedTask.streams;

              let newTask =  taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
              newTask.elements = importedTaskNode;
              newTask.streams = importedTaskLink;

              setSelectedItem(importDataByTree.node);
              //更新树
              let newTaskList = taskListRef.current;
              setTaskList(newTaskList);

              //执行保存
              pendingSaveRef.current = true;

              setImportDataByTree(null);
              setImportVariable(false);
            }
            else if(importType==="importElement")
            {
              //导入选中元件
              let importedTaskNode = importedTask.elements.find(item=>item.engName===importDataByTree.node.data.type).children;
              let selectNodeKey = importDataByTree.node.data.key;

              let newTask= taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
              if(newTask.elements.find(item=>item.engName===importDataByTree.node.data.type).children.findIndex(item => item.data.key===selectNodeKey)!==-1)
              {
                let newTaskElement = importedTaskNode.find(item=>item.data.key===selectNodeKey);
                newTask.elements.find(item=>item.engName===importDataByTree.node.data.type).children[newTask.elements.find(item=>item.engName===importDataByTree.node.data.type).children.findIndex(item => item.data.key===selectNodeKey)] = newTaskElement;
              }

              setSelectedItem(importDataByTree.node);
              //更新树
              let newTaskList = taskListRef.current;
              setTaskList(newTaskList);

              //执行保存
              pendingSaveRef.current = true;

              setImportDataByTree(null);
              setImportVariable(false);
            }
            else if(importType==="importStream")
            {
              //导入选中流股
              let importedTaskLink = importedTask.streams;
              let selectLinkKey = importDataByTree.node.data.key;

              let newTask= taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
              if(newTask.streams.findIndex(item => item.data.key===selectLinkKey)!==-1)
              {
                let newTaskStream = importedTaskLink.find(item=>item.data.key===selectLinkKey);
                newTask.streams[newTask.streams.findIndex(item => item.data.key===selectLinkKey)] = newTaskStream;
              }

              setSelectedItem(importDataByTree.node);
              //更新树
              let newTaskList = taskListRef.current;
              setTaskList(newTaskList);

              //执行保存
              pendingSaveRef.current = true;

              setImportDataByTree(null);
              setImportVariable(false);
            }
            else
            {
              messageApi.open
              ({
                type: "error",
                content: "导入类型非法",
              });
            }
          }
          else
          {
            messageApi.open
            ({
              type: "error",
              content: "被导入的数据非法",
            });
          }
        }
        else
        {
          messageApi.open
          ({
            type: "error",
            content: "请选择被导入的任务",
          });
        }
      }
      else if(selectImportButton==="design"||selectImportButton==="real")
      {
        if(selectDesId)
        {
          let selectDes = await queryDesById(selectDesId);
          if(selectDes)
          {
            let importedDes = selectDes["values"]["mix_input"];
            //① 原始数据（老链路-设计值/实际值来源）：queryDesById 返回的整条设计值/实际值记录
            console.log("[导入数据①原始数据-老链路] 设计值/实际值记录（接口原样）:", {
              importType: importDataByTree.key,
              selectDesId,
              record: selectDes,
            });
            //② 解析后：从原始记录里取出的 mix_input（elements/streams）
            console.log("[导入数据②解析后-老链路] mix_input 中的 elements/streams:", {
              importedDes,
            });
            if(importedDes)
            {
              if(importedDes.elements.length>0 || importedDes.streams.length>0)
              {
                //判断导入类型
                let importType = importDataByTree.key;
                const token = userInfo.access_token;
                if(importType==="importjob")
                {
                  //全部导入
                  let importedDesNode = importedDes.elements;
                  let importedDesLink = importedDes.streams;

                  // let newTask =  taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
                  // newTask.elements = importedDesNode;
                  // newTask.streams = importedDesLink;

                  let input = 
                  {
                      flow_id:stateParams.f,
                      name:importDataByTree.node.job_name,
                      description: state.curFlow["description"] || "",
                      cal:"False",
                      input:JSON.stringify(
                        {
                            selected_blocks: selectedElements,
                            global_physical_method: state.globle_physical_method,
                            elements:importedDesNode,
                            streams:importedDesLink,
                        })
                  };
                  const res = await updateJob(importDataByTree.node.job_id, input, token);
                  if (res.status === 200) 
                  {
                    message.success("导入成功");

                    //保存成功触发刷新
                    queryTask();
                  } 
                  else 
                  {
                    message.error(`导入失败：${res.status}`);
                  }

                  setImportDataByTree(null);
                  setImportVariable(false);
                }
                else if(importType==="importElement")
                {
                  //导入选中元件
                  let importedDesNode = importedDes.elements;
                  let selectNodeKey = importDataByTree.node.data.key;

                  let newTask= taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
                  let input = buildTaskInput(newJsonData ?? jsonData,allItemNames,state,"False",importDataByTree.node.job_name,"save");
                  if(newTask.elements.find(item=>item.engName===importDataByTree.node.data.type).children.findIndex(item => item.data.key===selectNodeKey)!==-1)
                  {
                    let newTaskElement = importedDesNode.find(item=>item.name===importDataByTree.node.item_name);
                    let newInput = JSON.parse(input["input"]);
                    newInput.elements[newInput.elements.findIndex(item => item.name===importDataByTree.node.item_name)] = newTaskElement;
                    input["input"] = JSON.stringify(newInput);
                  }

                  const res = await updateJob(importDataByTree.node.job_id, input, token);
                  if (res.status === 200) 
                  {
                    message.success("导入成功");

                    //保存成功触发刷新
                    queryTask();
                  } 
                  else 
                  {
                    message.error(`导入失败：${res.status}`);
                  }

                  setImportDataByTree(null);
                  setImportVariable(false);
                }
                else if(importType==="importStream")
                {
                  //导入选中流股
                  let importedDesLink = importedDes.streams;
                  let selectLinkKey = importDataByTree.node.data.key;

                  let newTask= taskListRef.current.find(item=>item.job_id===importDataByTree.node.job_id);
                  let input = buildTaskInput(newJsonData ?? jsonData,allItemNames,state,"False",importDataByTree.node.job_name,"save");
                  if(newTask.streams.findIndex(item => item.data.key===selectLinkKey)!==-1)
                  {
                    let newTaskStream = importedDesLink.find(item=>item.name===importDataByTree.node.item_name);
                    let newInput = JSON.parse(input["input"]);
                    newInput.streams[newTask.streams.findIndex(item => item.name===importDataByTree.node.item_name)] = newTaskStream;
                    input["input"] = JSON.stringify(newInput);
                  }

                  const res = await updateJob(importDataByTree.node.job_id, input, token);
                  if (res.status === 200) 
                  {
                    message.success("导入成功");

                    //保存成功触发刷新
                    queryTask();
                  } 
                  else 
                  {
                    message.error(`导入失败：${res.status}`);
                  }

                  setImportDataByTree(null);
                  setImportVariable(false);
                }
                else
                {
                  messageApi.open
                  ({
                    type: "error",
                    content: "导入类型非法",
                  });
                }
              }
              else
              {
                messageApi.open
                ({
                  type: "error",
                  content: "被导入的数据非法",
                });
              }
            }
            else
            {
              messageApi.open
              ({
                type: "error",
                content: "被导入的数据非法",
              });
            }
          }
        } 
        else
        {
          messageApi.open
          ({
            type: "error",
            content:`请选择被导入的${selectImportButton==="design"?"设计值":"实际值"}`,
          });
        }
      }
    }
    else
    {
      messageApi.open
      ({
        type: "error",
        content: "选中数据有误",
      });
    }
  };

  const refreshErrorNotice = () =>
  {
    //先关闭报错弹窗
    if (closeErrorNoticeRef.current) 
    {
      closeErrorNoticeRef.current();
      closeErrorNoticeRef.current = null; // 清空，避免重复关闭
    }
    const context = errorNoticeContextRef.current;
    if(context)
    {
      let contextValidInfo = context.validInfo;
      let elementsErrors = contextValidInfo.elementsErrors;

      if(elementsErrors!=="ok" && Array.isArray(elementsErrors) && elementsErrors.length > 0)
      {
        let errorElementNames = [];
        for(let i=0;i<elementsErrors.length;i++)
        {
          let errorElementName = elementsErrors[i].name;
          if(!errorElementNames.includes(errorElementName))
          {
            errorElementNames.push(errorElementName);
          }
        }

        if(errorElementNames.length>0)
        {
          //再重新判定报错
          let input = buildTaskInput(newJsonData ?? jsonData,errorElementNames,state,"True","","creat");

          //校验数据合法性
          const validInfo = validateInput(input["mix_input"]);
          if (!(validInfo === "ok")) 
          {
            //校验不通过
            let openErrorNotificationJsonData = newJsonData ?? jsonData;
            openErrorNotificationJsonData.job_id = selectedItem.job_id;
            openErrorNotificationJsonData.job_name = selectedItem.job_name;

            const closeFn = openErrorNotification(
              validInfo,
              notificationApi,
              notificationKey,
              setSelectedItem,
              openErrorNotificationJsonData,
              selectElement,
              setIsNowNeedOpenPramDrawer,
            );
            if (closeFn) 
            {
              closeErrorNoticeRef.current = closeFn;
              errorNoticeContextRef.current = {
                close: closeFn,
                validInfo: validInfo,
                jsonData: openErrorNotificationJsonData,
                notificationKey: notificationKey,
              };
            }
          }
        }
      }
    }
  };

  const changeLinkFlow = (linkNames,flowEnabled) =>
  {
    setChangeLinkFlowValue({linkNames:linkNames,flowEnabled:flowEnabled});
  };

  return (
    <>
      {contextHolder}
      {/* {loadingVariable ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(150,170,200,0.3)",
            zIndex: 1000,
            fontSize: 44,
            fontWeight: "bold",
            color: "#1b6ae7",
          }}
        >
          <LoadingOutlined style={{ fontSize: 48, marginRight: 30 }} />
          <span>计算中</span>
        </div>
      ) : null} */}
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          border: "1px solid #BBB",
          backgroundColor: "rgb(241, 238, 238)",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            minHeight: 40,
            borderBottom: "1px solid #BBB",
          }}
        >
          <button
            onClick={() => {
              setSelectButton("分组");
            }}
            style={{
              flex: 1,
              border: 0,
              borderRadius: 0,
              background: selectButton === "分组" ? "#1b6ae7" : "#EEE",
              color: selectButton === "分组" ? "#FFF" : "#888",
              fontSize: 14,
            }}
          >
            工艺段
          </button>
          <button
            onClick={() => {
              setSelectButton("计算任务");
            }}
            style={{
              flex: 1,
              borderLeft:"1px solid #BBB",
              borderRight:"1px solid #BBB",
              borderTop:0,
              borderBottom:0,
              borderRadius: 0,
              background: selectButton === "计算任务" ? "#1b6ae7" : "#EEE",
              color: selectButton === "计算任务" ? "#FFF" : "#888",
              fontSize: 14,
            }}
          >
            计算任务
          </button>
          <button
            onClick={() => {
              setSelectButton("设计值");
            }}
            style={{
              flex: 1,
              border:0,
              borderRadius: 0,
              background: selectButton === "设计值" ? "#1b6ae7" : "#EEE",
              color: selectButton === "设计值" ? "#FFF" : "#888",
              fontSize: 14,
            }}
          >
            设计值/运行数据
          </button>
        </div>

        <div
          style={{
            display: selectButton === "计算任务" ? "flex" : "none",
            flex: 1,
            width: "100%",
            height: "calc(100% - 100px)",
          }}
        >
          {taskList.length > 0 ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                overflowY: "auto",
                padding: 0,
                backgroundColor: "#FFF",
              }}
            >
              <TreeMenu
                data={taskList}
                selectedNode={selectedItem}
                setSelectedNode={setSelectedItem}
                alreadyTaskIds={alreadyTaskIds}
                setAlreadyTaskIds={(newAlreadyTaskIds) => {
                  setAlreadyTaskIds(newAlreadyTaskIds);
                }}
                setTaskList={(newTaskList) => {
                  setTaskList(newTaskList);
                }}
                jsonData={jsonData}
                onClickEvent={(taskId, elementType, elementName, data) => {
                  onClick(taskId, elementType, elementName, data);
                }}
                newTreeData={newTreeData}
                clearSelect={clearSelectVariable}
                state={state}
                resultDrawOpen={resultDrawOpen}
                setResultDrawOpen={setResultDrawOpen}
                setGroupeCalOpen={setGroupeCalOpen}
                setImportVariable = {(key,node)=>{queryDes();setImportDataByTree({key:key,node:node,selectJobId:null,selectDesId:null});setSelectImportButton(key==="importCombo"?"combo":"task");setOtherProjectId(null);setOtherFlowId(null);setOtherJobId(null);setOtherFlowList([]);setOtherJobList([]);setImportVariable(true);}}
                expandFirstItemVariable={expandFirstItemVariable}
                setCreatDesign={(key,node)=>{
                  setCreatDesName("")
                  setSelectCreatButton("design")
                  setCreatDesNameVariable({open:true,isRule:false});
                }}
                setRunElement={(key,node,maxWaitMinutes)=>{setLoadingVariable(true);runPartTask(node,maxWaitMinutes);}}
                setCreatTaskNameVariable={(newCreatTaskNameVariable)=>{setCreatTaskNameVariable(newCreatTaskNameVariable);}}
                setRunjob={(maxWaitMinutes)=>{saveTask("run",true,false,undefined,false,undefined,maxWaitMinutes);}}
                setRunComboTask={(jobId,name,runs,maxWaitMinutes,lastSubjobId)=>{runComboTask(jobId,name,runs,maxWaitMinutes,lastSubjobId);}}
                setCurResultInfo={setCurResultInfo}
                setUpTaskNameVariable={(newUpTaskNameVariable)=>{setCreatTaskName(selectedItem.job_name);setUpTaskNameVariable(newUpTaskNameVariable);}}
                setDeleteJob={(node)=>{deleteTask(node.job_id);}}
                expandedJobsVariable={expandedJobsVariable}
                // savedCurTaskJson={savedCurTaskJson}
                needSaveTaskVariable={needSaveTaskVariable}
                openSaveWarning={async(newTaskId)=>{await saveTask("save",false);}}
                setSelectGroup={(newSelectGroup)=>{
                  setSelectGroup(newSelectGroup);
                  setTaskListSelectGroup(newSelectGroup);
                }}
                setIsNowNeedOpenPramDrawer={(newIsNowNeedOpenPramDrawer)=>{setIsNowNeedOpenPramDrawer(newIsNowNeedOpenPramDrawer)}}
                upParamDrawer={(node)=>{upParamDrawer(node);}}
              />
              {/* <Menu
                  onOpenChange={async(e)=>{onOpenChange(e);}}
                  onClick={(e)=>{onClick(e);}}
                  style={{height:1}}
                  multiple={false}
                  mode="inline"
                  items={taskList}
              /> */}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                color: "#5F5F5F",
                fontSize: 18,
                backgroundColor:"#FFF"
              }}
            >
              暂无计算任务
            </div>
          )}
        </div>

        <div
          style={{
            display: selectButton === "设计值" ? "flex" : "none",
            flex: 1,
            width: "100%",
            height: "100%",
            backgroundColor: "#FFF",
          }}
        >
          <DesignTree
            creatDesVariable={creatDesVariable}
            isCreatDes={() => {
              setButtonAbled(true);
            }}
            creatDesType={creatDesType}
            refreshDesVariable={refreshDesVariable}
            taskListWidth={taskListWidth}
          />
        </div>

        <div
          style={{
            display: selectButton === "分组"? "flex" : "none",
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: "#FFF",
            borderBottom:0,
            paddingTop:13,
            height: "100%",
            width: "100%",
            overflowY: "auto",
          }}
        >
          {sortGroupsByDisplayOrder(groups).map((item) => (
            <button
              onClick={()=>{
                if(selectGroup)
                {
                  if(selectGroup.key===item.key)
                  {
                    setSelectGroup(null);
                    setTaskListSelectGroup(null);
                  }
                  else
                  {
                    setSelectGroup(item);
                    setTaskListSelectGroup(item);
                  }
                }
                else
                {
                  setSelectGroup(item);
                  setTaskListSelectGroup(item);
                }
              }}
              style={{
                width:"100%",
                minHeight:40,
                border:0,
                background:selectGroup?.key===item.key?"#e6f2ff":"#FFF",
                color:selectGroup?.key===item.key?"#0066cc":"#5F5F5F",
                fontWeight:selectGroup?.key===item.key?"bold":"normal",
                fontSize: 14,
              }}
            >
              {item.groupName}
            </button>
          ))}
          {groups.length===0?(
            <div
              style={{
                  display: "flex",
                  flex:1,
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#5F5F5F",
                  fontSize: 18,
                  backgroundColor:"#FFF"
                }}
            >
              暂无分组
            </div>
          ):null}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
            minHeight: 60,
            borderTop: "1px solid #BBB",
          }}
        >
          <button
            onClick={() => {
              if (selectButton === "设计值") {
                setButtonAbled(false);
                setCreatDesVariable(creatDesVariable + 1);
                setCreatDesType("设计");
              } else if (selectButton === "计算任务") 
              {
                setCreatTaskNameVariable({open:true,isCopy:false});
              }
            }}
            disabled={!buttonAbled}
            style={{
              display: selectButton === "计算任务"?"flex":"none",
              alignItems: "center",
              justifyContent: "center",
              width: selectButton === "设计值" ? "32%" : "35%",
              height: "60%",
              border: 0,
              borderRadius: 5,
              background: buttonAbled ? "#1b6ae7" : "#7fa7e7",
              color: "#FFF",
              fontSize: 14,
            }}
          >
            <LoadingOutlined style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }} />
            <span>{selectButton === "设计值" ? "创建设计值" : "创建任务"}</span>
          </button>
          {/* {selectButton === "设计值" ? (
            <button
              onClick={() => {
                if (selectButton === "设计值") {
                  setButtonAbled(false);
                  setCreatDesVariable(creatDesVariable + 1);
                  setCreatDesType("实际");
                } else if (selectButton === "计算任务") {
                  setCreatTaskNameVariable({open:true,isCopy:false});
                }
              }}
              disabled={!buttonAbled}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: selectButton === "设计值" ? "32%" : "35%",
                height: "60%",
                border: 0,
                borderRadius: 5,
                background: buttonAbled ? "#1b6ae7" : "#7fa7e7",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              <LoadingOutlined
                style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }}
              />
              <span>{selectButton === "设计值" ? "创建运行数据" : "创建任务"}</span>
            </button>
          ) : null} */}
          <button
            onClick={() => {
              close();
            }}
            style={{
              // width: selectButton === "设计值" ? "25%" : "35%",
              width:"35%",
              height: "60%",
              border: "1px solid #BBB",
              borderRadius: 5,
              background: "rgb(0,0,0,0)",
              color: "#888",
              fontSize: 14,
            }}
          >
            关闭
          </button>
        </div>
      </div>

      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={500}
        className={"modal"}
        open={importVariable}
        zIndex={9000000}
        onCancel={() => {setImportDataByTree(null);setImportVariable(false);}}
      >
        {importDataByTree?(
          <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
            {`导入输入参数至 ${importDataByTree.node.item_name}`}
          </div>
        ):null}
        <div style={{display:"flex",flexDirection: "row",marginBottom:30}}>
          <button
            onClick={() => 
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
                setSelectImportButton("task");
              }}
            style={{width:75,height:25,borderTop:selectImportButton==="task"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="task"?"0px":"1px solid #BBB",borderLeft:selectImportButton==="task"?"0px":"1px solid #BBB",borderRight:0,borderRadius:0,background:selectImportButton==="task"?"#1b6ae7":"#FFF",color:selectImportButton==="task"?"#FFF":"#BBB",fontSize: 14}}
          >
            计算任务
          </button>
          <button
            onClick={() => 
            {
              setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
              setSelectImportButton("design");
            }}
            style={{width:75,height:25,borderTop:selectImportButton==="design"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="design"?"0px":"1px solid #BBB",borderLeft:selectImportButton==="design"?"0px":"1px solid #BBB",borderRight:0,borderRadius:0,background:selectImportButton==="design"?"#1b6ae7":"#FFF",color:selectImportButton==="design"?"#FFF":"#BBB",fontSize: 14}}
          >
            设计值
          </button>
          <button
            onClick={() => 
            {
              setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
              setSelectImportButton("real");
            }}
            style={{width:75,height:25,borderTop:selectImportButton==="real"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="real"?"0px":"1px solid #BBB",borderRight:selectImportButton==="real"?"0px":((importDataByTree?.key==="importCombo"||importDataByTree?.key==="importElement"||importDataByTree?.key==="importjob")?"0px":"1px solid #BBB"),borderLeft:selectImportButton==="real"?"0px":"1px solid #BBB",borderRadius:0,background:selectImportButton==="real"?"#1b6ae7":"#FFF",color:selectImportButton==="real"?"#FFF":"#BBB",fontSize: 14}}
          >
            实际值
          </button>
          {importDataByTree?.key==="importCombo" && (
          <button
            onClick={() => 
            {
              setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
              setSelectImportButton("combo");
            }}
            style={{width:90,height:25,borderTop:selectImportButton==="combo"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="combo"?"0px":"1px solid #BBB",borderRight:selectImportButton==="combo"?"0px":"1px solid #BBB",borderLeft:selectImportButton==="combo"?"0px":"1px solid #BBB",borderRadius:0,background:selectImportButton==="combo"?"#1b6ae7":"#FFF",color:selectImportButton==="combo"?"#FFF":"#BBB",fontSize: 14}}
          >
            组合计算
          </button>
          )}
          {importDataByTree?.key==="importElement" && (
          <button
            onClick={() => 
            {
              setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
              setSelectImportButton("elementRun");
            }}
            style={{width:90,height:25,borderTop:selectImportButton==="elementRun"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="elementRun"?"0px":"1px solid #BBB",borderRight:selectImportButton==="elementRun"?"0px":"1px solid #BBB",borderLeft:selectImportButton==="elementRun"?"0px":"1px solid #BBB",borderRadius:0,background:selectImportButton==="elementRun"?"#1b6ae7":"#FFF",color:selectImportButton==="elementRun"?"#FFF":"#BBB",fontSize: 14}}
          >
            元件其他任务
          </button>
          )}
          {importDataByTree?.key==="importjob" && (
          <button
            onClick={() => 
            {
              setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:null
                }));
              setSelectImportButton("otherProject");
              //首次进入该来源时加载项目列表
              if(otherProjectList.length===0){loadOtherProjects();}
            }}
            style={{width:95,height:25,borderTop:selectImportButton==="otherProject"?"0px":"1px solid #BBB",borderBottom:selectImportButton==="otherProject"?"0px":"1px solid #BBB",borderRight:selectImportButton==="otherProject"?"0px":"1px solid #BBB",borderLeft:selectImportButton==="otherProject"?"0px":"1px solid #BBB",borderRadius:0,background:selectImportButton==="otherProject"?"#1b6ae7":"#FFF",color:selectImportButton==="otherProject"?"#FFF":"#BBB",fontSize: 14}}
          >
            其他项目流程
          </button>
          )}
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          {importDataByTree && selectImportButton==="task" ?(
            <Select
              placeholder={"请选择需要导入的计算任务"}
              value={importDataByTree?.selectJobId}
              onChange={(selectedValue) =>
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:selectedValue,
                  selectDesId:null
                }))
              }}
              style={{width:"100%"}}
              allowClear={true}
              options={taskList.filter(item=>item.job_id!==importDataByTree.node.job_id).map((item)=>({label:item.jobname,value:item.job_id}))}
            />
          ):null}
          {importDataByTree && selectImportButton==="design" ?(
            <Select
              placeholder={"请选择需要导入的设计值"}
              value={importDataByTree?.selectDesId}
              onChange={(selectedValue) =>
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:selectedValue
                }))
              }}
              style={{width:"100%"}}
              allowClear={true}
              options={desList.filter(Item=>Item.type==="design").map((item)=>({label:item.values?.name??`设计值${item.id}`,value:item.id}))}
            />
          ):null}
          {importDataByTree && selectImportButton==="real" ?(
            <Select
              placeholder={"请选择需要导入的实际值"}
              value={importDataByTree?.selectDesId}
              onChange={(selectedValue) =>
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:selectedValue
                }))
              }}
              style={{width:"100%"}}
              allowClear={true}
              options={desList.filter(Item=>Item.type==="actual").map((item)=>({label:item.values?.name??`实际值${item.id}`,value:item.id}))}
            />
          ):null}
          {importDataByTree && selectImportButton==="combo" ?(
            <Select
              placeholder={"请选择需要导入的组合计算结果"}
              value={importDataByTree?.selectDesId}
              onChange={(selectedValue) =>
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:selectedValue
                }))
              }}
              style={{width:"100%"}}
              allowClear={true}
              options={(importDataByTree?.node?.runs||[])
                //仅可选择计算成功且收敛的组合运行结果
                .filter((item:any)=>item.status==="done" && item.is_converged!==false)
                .map((item:any)=>({label:dayjs(item.created_at).add(8,"hours").format("YYYY-MM-DD HH:mm:ss"),value:item.id}))}
            />
          ):null}
          {importDataByTree && selectImportButton==="elementRun" ?(
            <Select
              placeholder={"请选择需要导入的元件任务"}
              value={importDataByTree?.selectDesId}
              onChange={(selectedValue) =>
              {
                setImportDataByTree((prev) => 
                ({
                  ...prev,
                  selectJobId:null,
                  selectDesId:selectedValue
                }))
              }}
              style={{width:"100%"}}
              allowClear={true}
              options={(importDataByTree?.node?.runs||[])
                //仅可选择计算成功且收敛的元件运行结果
                .filter((item:any)=>item.status==="done" && item.is_converged!==false)
                .map((item:any,index:number)=>({
                  label:item.created_at?dayjs(item.created_at).add(8,"hours").format("YYYY-MM-DD HH:mm:ss"):`运行记录 ${index+1}`,
                  value:item.id
                }))}
            />
          ):null}
          {importDataByTree && selectImportButton==="otherProject" ?(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <Select
                placeholder={"请选择需要导入的项目"}
                value={otherProjectId ?? undefined}
                onChange={(selectedValue) =>
                {
                  setOtherProjectId(selectedValue);
                  //切换项目后清空流程/任务，并加载该项目的流程
                  setOtherFlowId(null);
                  setOtherJobId(null);
                  setOtherFlowList([]);
                  setOtherJobList([]);
                  loadOtherFlows(selectedValue);
                }}
                style={{width:"100%"}}
                allowClear={true}
                showSearch={true}
                optionFilterProp="label"
                loading={otherLoading}
                options={otherProjectList.map((item:any)=>({label:item.name,value:item.id}))}
              />
              <Select
                placeholder={"请选择需要导入的流程"}
                value={otherFlowId ?? undefined}
                onChange={(selectedValue) =>
                {
                  setOtherFlowId(selectedValue);
                  //切换流程后清空任务，并加载该流程下计算成功的任务
                  setOtherJobId(null);
                  setOtherJobList([]);
                  loadOtherJobs(selectedValue);
                }}
                style={{width:"100%"}}
                allowClear={true}
                showSearch={true}
                optionFilterProp="label"
                loading={otherLoading}
                disabled={!otherProjectId}
                options={otherFlowList.map((item:any)=>({label:item.name,value:item.id}))}
              />
              <Select
                placeholder={"请选择需要导入的计算任务"}
                value={otherJobId ?? undefined}
                onChange={(selectedValue) => {setOtherJobId(selectedValue);}}
                style={{width:"100%"}}
                allowClear={true}
                showSearch={true}
                optionFilterProp="label"
                disabled={!otherFlowId}
                options={otherJobList.map((item:any)=>({label:item.name,value:item.id}))}
                notFoundContent="暂无计算成功的任务"
              />
            </div>
          ):null}
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setImportDataByTree(null);setImportVariable(false);}}
            disabled={!buttonAbled}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14}}>
            取消
          </button>
          <button
            onClick={async() => 
            {
              setButtonAbled(false);
              await importData();
              setButtonAbled(true);
            }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={!buttonAbled}
          >
            <LoadingOutlined style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>

      {/* 流程图右键「运行单元操作」：确认计算 + 最大计算时间 + 输入参数预览 */}
      <Modal
        title="是否确认运行单元操作"
        open={!!runPartConfirmData}
        onOk={confirmRunPartTask}
        onCancel={() => setRunPartConfirmData(null)}
        okText="确认"
        cancelText="取消"
        maskClosable={false}
        width={1000}
        zIndex={9000000}
      >
        <div style={{ marginBottom: 12 }}>
          <GroupCalParamsPreview
            //每次打开弹窗都回到「收起」的初始状态
            key={runPartConfirmData ? "run-part-open" : "run-part-closed"}
            defaultCollapsed
            jsonData={newJsonData ?? jsonData}
            selectedElements={
              runPartConfirmData?.selectNode?.item_name
                ? [runPartConfirmData.selectNode.item_name]
                : []
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>最大计算时间：</span>
          <InputNumber
            value={runPartMaxWait}
            onChange={(v) => setRunPartMaxWait(v ?? null)}
            style={{ width: 120 }}
            min={1}
          />
          <span>分</span>
        </div>
      </Modal>

      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={400}
        className={"modal"}
        open={creatTaskNameVariable?.open ?? false}
        zIndex={9000000}
        onCancel={() => {setCreatTaskName("");setCreatTaskNameVariable(null);setButtonAbled(true);}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          任务名称
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          <Input
            value={creatTaskName}
            onChange={(e) => {setCreatTaskName(e.target.value);}}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setCreatTaskName("");setCreatTaskNameVariable(null);setButtonAbled(true);}}
            disabled={!buttonAbled}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14,}}>
            取消
          </button>
          <button
            onClick={async() => 
              {
                setButtonAbled(false);
                let res = await saveTask("creat", false,false,null,creatTaskNameVariable.isCopy,creatTaskNameVariable);
                if(res)
                {
                  setCreatTaskName("");
                  setButtonAbled(true);
                  setCreatTaskNameVariable(null);
                }
                else 
                {
                  setButtonAbled(true);
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={!buttonAbled}
          >
            <LoadingOutlined style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>
      
      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={400}
        className={"modal"}
        open={creatDesNameVariable?.open ?? false}
        zIndex={9000000}
        onCancel={() => {setCreatDesName("");setCreatDesNameVariable(null);setButtonAbled(true);}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          {`${selectCreatButton==="design"?"设计值":"运行数据"}名称`}
        </div>
        <div style={{display:"flex",flexDirection: "row",marginBottom:30}}>
          <button
            onClick={() => 
            {
              setSelectCreatButton("design");
              setCreatDesNameVariable({open:true,isRule:false});
            }}
            style={{width:75,height:25,borderTop:selectCreatButton==="design"?"0px":"1px solid #BBB",borderBottom:selectCreatButton==="design"?"0px":"1px solid #BBB",borderLeft:selectCreatButton==="design"?"0px":"1px solid #BBB",borderRight:0,borderRadius:0,background:selectCreatButton==="design"?"#1b6ae7":"#FFF",color:selectCreatButton==="design"?"#FFF":"#BBB",fontSize: 14}}
          >
            设计值
          </button>
          <button
            onClick={() => 
            {
              setSelectCreatButton("real");
              setCreatDesNameVariable({open:true,isRule:true});
            }}
            style={{width:75,height:25,borderTop:selectCreatButton==="real"?"0px":"1px solid #BBB",borderBottom:selectCreatButton==="real"?"0px":"1px solid #BBB",borderRight:selectCreatButton==="real"?"0px":"1px solid #BBB",borderLeft:selectCreatButton==="real"?"0px":"1px solid #BBB",borderRadius:0,background:selectCreatButton==="real"?"#1b6ae7":"#FFF",color:selectCreatButton==="real"?"#FFF":"#BBB",fontSize: 14}}
          >
            运行数据
          </button>
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          <Input
            value={creatDesName}
            onChange={(e) => {setCreatDesName(e.target.value);}}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setCreatDesName("");setCreatDesNameVariable(null);setButtonAbled(true);}}
            disabled={!buttonAbled}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14,}}>
            取消
          </button>
          <button
            onClick={async() => 
              {
                setButtonAbled(false);
                let res = await saveTask("creat",false,true);;
                if(res)
                {
                  setCreatDesName("");
                  setCreatDesNameVariable(null);
                  setButtonAbled(true);
                }
                else 
                {
                  setButtonAbled(true);
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={!buttonAbled}
          >
            <LoadingOutlined style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>
      
      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={400}
        className={"modal"}
        open={upTaskNameVariable}
        zIndex={9000000}
        onCancel={() => {setCreatTaskName("");setUpTaskNameVariable(null);setButtonAbled(true);}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          任务名称
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          <Input
            value={creatTaskName}
            onChange={(e) => {setCreatTaskName(e.target.value);}}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setCreatTaskName("");setUpTaskNameVariable(null);setButtonAbled(true);}}
            disabled={!buttonAbled}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14,}}>
            取消
          </button>
          <button
            onClick={async() => 
              {
                setButtonAbled(false);
                let res = await saveTask("save", false,false,null,false);
                if(res)
                {
                  setCreatTaskName("");
                  setUpTaskNameVariable(null);
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:buttonAbled ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={!buttonAbled}
          >
            <LoadingOutlined style={{ display: buttonAbled ? "none" : "flex", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>

    </>
  );
};

export default TaskList;
